"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsuranceClaimType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var InsuranceClaimType_Factory = /** @class */ (function () {
    function InsuranceClaimType_Factory() {
    }
    InsuranceClaimType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    InsuranceClaimType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    return InsuranceClaimType_Factory;
}());
exports.InsuranceClaimType_Factory = InsuranceClaimType_Factory;
